import mutations from './ekatalogus.mutations'
import actions from './ekatalogus.actions'
import getters from './ekatalogus.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
